import React from "react";
import styled from "styled-components";

const Foot = styled.footer`
  padding: 24px 0;
  text-align: center;
  font-size: 13px;

  /* 🔥 Dark footer background */
  background: ${(p) =>
    p.theme.colors.bgDarker || "linear-gradient(180deg, #0a0f1d, #060a13)"};

  border-top: 1px solid rgba(255, 255, 255, 0.06);

  color: ${(p) => p.theme.colors.muted};
`;

const FooterInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 10px 16px;
`;

const FooterLink = styled.a`
  color: ${(p) => p.theme.colors.text};
  opacity: 0.75;
  text-decoration: none;

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

export default function Footer() {
  return (
    <Foot>
      <FooterInner>
        © {new Date().getFullYear()} K Shyam G Management — All rights reserved.
        &nbsp; | &nbsp;
        <FooterLink href="#privacy">Privacy</FooterLink>
      </FooterInner>
    </Foot>
  );
}
